import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import ModuleTagsWidget from "widgets/ModuleTagsWidget";
import { useModulesPage } from "../../context";
import ActionButtons from "./components/ActionButtons";
import Tabs from "./components/Tabs";
import General from "./components/Tabs/Content/General";
import SelectedGames from "./components/Tabs/Content/SelectedGames";
import StudioOrdering from "./components/Tabs/Content/StudioOrdering";
import Studios from "./components/Tabs/Content/Studios";
import Translations from "./components/Tabs/Content/Translations";
import { ModuleDetailsProvider, useModuleDetails } from "./context";
import { ModuleDetailsTabs } from "./context/types";

const ModuleDetailsDrawerContainer: FC = () => (
  <ModuleDetailsProvider>
    <ModuleDetailsDrawer />
  </ModuleDetailsProvider>
);

const TAB_CONTENT: Record<ModuleDetailsTabs, FC> = {
  [ModuleDetailsTabs.General]: General,
  [ModuleDetailsTabs.Tags]: ModuleTagsWidget,
  [ModuleDetailsTabs.SelectedGames]: SelectedGames,
  [ModuleDetailsTabs.StudioOrdering]: StudioOrdering,
  [ModuleDetailsTabs.Studios]: Studios,
  [ModuleDetailsTabs.Translations]: Translations,
};

const ModuleDetailsDrawer: FC = () => {
  const { moduleDetailsDrawer } = useModulesPage();
  const { moduleId, handleDrawerClose, selectedTab } = useModuleDetails();

  const title = moduleId ? "Edit module" : "Add new module";
  const ContentComponent = TAB_CONTENT[selectedTab];

  return (
    <Drawer
      title={title}
      isOpen={moduleDetailsDrawer.isOpen}
      onCloseDrawer={handleDrawerClose}
      headingRight={<ActionButtons />}
      headingBottom={<Tabs />}
    >
      <ContentComponent />
    </Drawer>
  );
};

export default ModuleDetailsDrawerContainer;
